import axios from "axios";
import { plainToInstance } from "class-transformer";
import { FeaturesDto } from "healthex-common/features.dtos";
import { apiConfig, authenticatedApiConfig, generateURL } from "./BaseApiService";
export class FeatureService {
    constructor(environment, authManager) {
        this.environment = environment;
        this.authManager = authManager;
    }
    async getGlobalFeatures() {
        var _a;
        const url = generateURL(this.environment.API_BASE_URL, "/features/global", {});
        const response = await axios.get(url, apiConfig());
        const featuresDto = response.data ? plainToInstance(FeaturesDto, response.data) : null;
        return (_a = featuresDto === null || featuresDto === void 0 ? void 0 : featuresDto.features) !== null && _a !== void 0 ? _a : [];
    }
    async getFeaturesForOrganization(organizationId) {
        var _a;
        const url = generateURL(this.environment.API_BASE_URL, "/organizations/:organizationId/features", { organizationId });
        const response = await axios.get(url, apiConfig());
        const featuresDto = response.data ? plainToInstance(FeaturesDto, response.data) : null;
        return (_a = featuresDto === null || featuresDto === void 0 ? void 0 : featuresDto.features) !== null && _a !== void 0 ? _a : [];
    }
    async getFeaturesForUser(userId, organizationId) {
        var _a;
        const url = generateURL(this.environment.API_BASE_URL, "/users/:userId/features", { userId });
        const baseConfig = await authenticatedApiConfig(this.authManager);
        const config = organizationId ? { ...baseConfig, params: { organizationId } } : baseConfig;
        const response = await axios.get(url, config);
        const featuresDto = response.data ? plainToInstance(FeaturesDto, response.data) : null;
        return (_a = featuresDto === null || featuresDto === void 0 ? void 0 : featuresDto.features) !== null && _a !== void 0 ? _a : [];
    }
}
